import _ from 'lodash';
import { api } from './NetworkUtility';
import { logError } from './ErrorService';

let paymentTrendsAbortController = new AbortController();

/*
    This method will retrieve payment data and transform it into the necessary structure to be used by
    the PaymentTrendsGraph component. The returned object contains graph and legend data for the payments receieved.
*/
export const getTrends = async (callbackErrorHandler, companyNumber, paymentTypeCode, startDate, endDate) => {
    if (companyNumber == null || typeof companyNumber === 'undefined') {
        return;
    }

    const url = `/companies/${companyNumber}/payments/paymentTypes/${paymentTypeCode}/startOn/${startDate}/endOn/${endDate}/trends`;

    // Abort any previous calls before retrieving new trends
    paymentTrendsAbortController.abort();
    paymentTrendsAbortController = new AbortController();

    return api.get(url, {
        signal: paymentTrendsAbortController.signal
    })
        .then((response) =>
            dataTransform(response.data)
        )
        .catch(function (error) {
            // Abort errors can be ignored 
            if (error?.code !== 'ERR_CANCELED') {
                //navigate hook does not work here, using window.location to redirect
                if (error?.response?.status === 401 || error?.response?.status === 403) {
                    //unauthorized user - log unauth attempt and redirect
                    logError("Unauthorized user attempt", () => {
                        window.location = "/unauthorizedUser?pt";
                    });
                } else {
                    console.log("Unable to retrieve Payment Trends information.");
                    callbackErrorHandler(error);
                }
            }
        });
}

const dataTransform = (data) => {
    let graphData = [];
    let legendData = [];

    // Generate date labels for xAxis
    let xAxis = generateXAxis(data.startOn, data.endOn);
    graphData.push(xAxis);

    // Group data by payment method and genereate each method's data array
    let groupedByPaymentMethod = _.groupBy(data.trends, 'paymentMethodDisplay');
    _.forEach(groupedByPaymentMethod, paymentMethod => {
        let paymentMethodData = generatePaymentMethodData(paymentMethod, xAxis);
        graphData.push(paymentMethodData);

        // Create legend data for payment method
        legendData.push(generateLegendData(paymentMethodData));
    });
    return ({
        graphData,
        legendData
    });
}

const generateXAxis = (startOn, endOn) => {
    let xAxis = ['X'];
    let startDate = new Date(startOn.replaceAll('-', '/'));
    let endDate = new Date(endOn.replaceAll('-', '/'));

    let oneDay = 1000 * 60 * 60 * 24;
    let numOfDays = Math.ceil((endDate - startDate) / oneDay);

    for (let i = 0; i < numOfDays; i++) {
        let parsedDate = parseDate(startDate);
        if (!xAxis.includes(parsedDate)) {
            xAxis.push(parsedDate);
        }
        startDate.setDate(startDate.getDate() + 1);
    }
    return xAxis;
}

const generatePaymentMethodData = (paymentMethod, xAxis) => {
    let paymentMethodArray = Array(xAxis.length).fill(0);
    paymentMethodArray[0] = `${paymentMethod[0].paymentMethodDisplay} Payments`;
    _.forEach(paymentMethod, payment => {
        let parsedDate = parseDate(new Date(payment.statusChangeDate.replaceAll('-', '/')));
        let index = _.indexOf(xAxis, parsedDate);
        paymentMethodArray[index] = paymentMethodArray[index] + payment.disbursementCount;
    })
    return paymentMethodArray;
}

const generateLegendData = (paymentMethodData) => {
    let legendData = [];
    legendData.push(paymentMethodData[0]);
    legendData.push(_.sum(_.drop(paymentMethodData)));
    return legendData;
}

const parseDate = date => {
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    let dateLabel = `${months[date.getUTCMonth()]} ${date.getDate()}`;
    return dateLabel;
}
